import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import ErrorModal from './ErrorModal';

const BoardTaxes = () => {
  const [taxes, setTaxes] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Loading, please wait...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  const [formData, setFormData] = useState({
    tax_name: '',
    tax_value: '',
    rec_date: ''
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData.tax_name.trim()) {
      newErrors.tax_name = 'Tax Name is required';
    }
    if (!formData.tax_value || isNaN(formData.tax_value) || formData.tax_value < 0) {
      newErrors.tax_value = 'Tax Value must be a positive number or 0';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  useEffect(() => {
    
    UserService.getTaxesBoard().then(
      (response) => {
        setTaxes(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setTaxes(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);


// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(taxes)
    ? taxes.filter((vo) =>
        (vo.tax_name && vo.tax_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
        (vo.tax_value && vo.tax_value.toLowerCase().includes(filterTerm.toLowerCase())) ||
        (vo.rec_date && vo.rec_date.includes(filterTerm))
      )
    : [];

// Get the current page's data
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);

 // Handle pagination
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

// Sorting function
const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};


// Sort the filtered data
const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
  if (a[sortConfig.key] < b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? -1 : 1;
  }
  if (a[sortConfig.key] > b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? 1 : -1;
  }
  return 0;
});


// Total pages calculation
const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);


  const handleEditClick = (tax) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedTax(tax);
    setFormData(tax);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      tax_name: "",
      tax_value: "",
      rec_date: ""
    });
    setShowCreateModal(true);
  };

  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText(' Deleting the data please wait...');
      setLoading(true);
      await UserService.deleteTaxesBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Tax:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Updating the data please wait...');
      setLoading(true);
      formData.rec_date = new Date();
      await UserService.updateTaxesBoard(selectedTax.tax_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Tax:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Creating the data please wait...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createTaxesBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Tax:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
   setFormData({
     ...formData,
     [e.target.name]: e.target.value
   });
 validateForm();
 };

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Tax Overview</h1>
      {/* Display error if it exists */}
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />
      <Button variant="info" onClick={() => handleCreateClick()} className="mr-2 mb-2">
                  Create
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only"> Loading...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Search by Area group name, id and rect date"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('tax_id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'tax_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('tax_name')} style={{ cursor: 'pointer' }}>
              Tax Name {sortConfig.key === 'tax_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('tax_value')} style={{ cursor: 'pointer' }}>
              Tax Value {sortConfig.key === 'tax_value' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('rec_date')} style={{ cursor: 'pointer' }}>
              Create Date {sortConfig.key === 'rec_date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedMainVOs.map((tax) => (
     
            <tr key={tax.tax_id}>
              <td>{tax.tax_id}</td>
              <td>{tax.tax_name}</td>
              <td>{tax.tax_value}</td>
              <td>{tax.rec_date}</td>
              <td>
              <ButtonGroup>
                <Button variant="warning" onClick={() => handleEditClick(tax)} className="mr-2">
                  Edit
                </Button>
                <Button variant="danger" onClick={(e) => handleDeleteClick(tax.tax_id,e)}>
                  Delete
                </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Tax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formTaxName">
              <Form.Label>Tax Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax name"
                name="tax_name"
                value={formData.tax_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.tax_name} // Show invalid state
              />
               <Form.Control.Feedback type="invalid">
                {errors.tax_name}
              </Form.Control.Feedback>
            </Form.Group>
            

            <Form.Group controlId="formTaxValue">
              <Form.Label>Tax Value</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                placeholder="Enter tax value"
                name="tax_value"
                value={formData.tax_value}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.tax_value} // Show invalid state
              />
              
              <Form.Control.Feedback type="invalid">
                {errors.tax_value}
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Saving...' : 'Saving Tax'}
             
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Tax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group controlId="formTaxName">
              <Form.Label>Tax Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax name"
                name="tax_name"
                value={formData.tax_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.tax_name} // Show invalid state
              />
             <Form.Control.Feedback type="invalid">
                {errors.tax_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formTaxValue">
              <Form.Label>Tax Value</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                placeholder="Enter tax value"
                name="tax_value"
                value={formData.tax_value}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.tax_value} // Show invalid state
              />
            <Form.Control.Feedback type="invalid">
                {errors.tax_value}
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Updating...' : 'Update Tax'}
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardTaxes;
